import { NgModule } from '@angular/core';
import { UserInfoComponent } from './user-info/user-info';
import { CommonModule } from '@angular/common';
import { SinRetosComponent } from './sin-retos/sin-retos';
import { ProximoRetoComponent } from './proximo-reto/proximo-reto';
import { RondaLiberadaComponent } from './ronda-liberada/ronda-liberada';
import { EsperaRondaComponent } from './espera-ronda/espera-ronda';
import { IonicModule } from 'ionic-angular'
import { ExisteGanadorComponent } from './existe-ganador/existe-ganador';
import { LoadingComponent } from './loading/loading';
import { ModalInsigniaComponent } from './modal-insignia/modal-insignia';
import { DirectivesModule } from '../directives/directives.module';
import { DisconnectComponent } from './disconnect/disconnect';
import { ModalRetoCaducadoComponent } from './modal-reto-caducado/modal-reto-caducado';
import { PipesModule } from '../pipes/pipes.module';
import { SkeletonImagenComponent } from './skeleton-imagen/skeleton-imagen';
import { ModalVersionAppComponent } from './modal-version-app/modal-version-app';
import { ModalSinOponenteComponent } from './modal-sin-oponente/modal-sin-oponente';
import { SkeletonSugerenciasComponent } from './skeleton-sugerencias/skeleton-sugerencias';
import { SkeletonListComponent } from './skeleton-list/skeleton-list';
import { SkeletonInsigniasComponent } from './skeleton-insignias/skeleton-insignias';
import { SkeletonEstadisticasComponent } from './skeleton-estadisticas/skeleton-estadisticas';
import { SkeletonRetoEquipoComponent } from './skeleton-reto-equipo/skeleton-reto-equipo';
import { SkeletonRetoEquipoRankingComponent } from './skeleton-reto-equipo-ranking/skeleton-reto-equipo-ranking';
import { SkeletonEstadisticasGraficaComponent } from './skeleton-estadisticas-grafica/skeleton-estadisticas-grafica';
import { SkeletonEstadisticasEfectividadComponent } from './skeleton-estadisticas-efectividad/skeleton-estadisticas-efectividad';
import { SkeletonEstadisticasCategoriasComponent } from './skeleton-estadisticas-categorias/skeleton-estadisticas-categorias';
import { CampaignActiveComponent } from './campaign-active/campaign-active';
import { ModalRetosPausadosComponent } from './modal-retos-pausados/modal-retos-pausados';
import { TranslateModule } from '@ngx-translate/core';
import { BusquedaTesoroCardComponent } from './busqueda-tesoro-card/busqueda-tesoro-card';
import { BusquedaTesoroNivelComponent } from './busqueda-tesoro-nivel/busqueda-tesoro-nivel';
import { NivelCardComponent } from './nivel-card/nivel-card';
import { PremiosGanadosCardComponent } from './premios-ganados-card/premios-ganados-card';
import { CardVideoComponent } from './card-video/card-video';
import { TemploSabiosCardComponent } from './templo-sabios-card/templo-sabios-card';
import { PreguntaOpcionesComponent } from './pregunta-opciones/pregunta-opciones';
import { PreguntaVerdaderoFalsoComponent } from './pregunta-verdadero-falso/pregunta-verdadero-falso';
import { PreguntaCreaComponent } from './pregunta-crea/pregunta-crea';
import { BusquedaTesoroActivoComponent } from './busqueda-tesoro-activo/busqueda-tesoro-activo';
import { BusquedaTesoroHeaderComponent } from './busqueda-tesoro-header/busqueda-tesoro-header';
import { MenuComponent } from './menu/menu';
import { ModalVideoComponent } from './modal-video/modal-video';
import { ModalAcercaDeComponent } from './modal-acerca-de/modal-acerca-de';

@NgModule({
	declarations: [UserInfoComponent,
    SinRetosComponent,
    ProximoRetoComponent,
    RondaLiberadaComponent,
    EsperaRondaComponent,
    ExisteGanadorComponent,
    LoadingComponent,
    ModalInsigniaComponent,
    DisconnectComponent,
    ModalRetoCaducadoComponent,
    SkeletonImagenComponent,
    ModalVersionAppComponent,
    ModalSinOponenteComponent,
    SkeletonSugerenciasComponent,
    SkeletonListComponent,
    SkeletonInsigniasComponent,
    SkeletonEstadisticasComponent,
    SkeletonRetoEquipoComponent,
    SkeletonRetoEquipoRankingComponent,
    SkeletonEstadisticasGraficaComponent,
    SkeletonEstadisticasEfectividadComponent,
    SkeletonEstadisticasCategoriasComponent,
    CampaignActiveComponent,
		ModalRetosPausadosComponent,
    BusquedaTesoroCardComponent,
    BusquedaTesoroNivelComponent,
    NivelCardComponent,
    PremiosGanadosCardComponent,
    CardVideoComponent,
    TemploSabiosCardComponent,
    PreguntaOpcionesComponent,
    PreguntaVerdaderoFalsoComponent,
    PreguntaCreaComponent,
    BusquedaTesoroActivoComponent,
    BusquedaTesoroHeaderComponent,
    MenuComponent,
    ModalVideoComponent,
    ModalAcercaDeComponent],
	imports: [ CommonModule, IonicModule, DirectivesModule, PipesModule, TranslateModule],
	exports: [UserInfoComponent,
    SinRetosComponent,
    ProximoRetoComponent,
    RondaLiberadaComponent,
    EsperaRondaComponent,
    ExisteGanadorComponent,
    LoadingComponent,
    ModalInsigniaComponent,
    DisconnectComponent,
    ModalRetoCaducadoComponent,
    SkeletonImagenComponent,
    ModalVersionAppComponent,
    ModalSinOponenteComponent,
    SkeletonSugerenciasComponent,
    SkeletonListComponent,
    SkeletonInsigniasComponent,
    SkeletonEstadisticasComponent,
    SkeletonRetoEquipoComponent,
    SkeletonRetoEquipoRankingComponent,
    SkeletonEstadisticasGraficaComponent,
    SkeletonEstadisticasEfectividadComponent,
    SkeletonEstadisticasCategoriasComponent,
    CampaignActiveComponent,
		ModalRetosPausadosComponent,
    BusquedaTesoroCardComponent,
    BusquedaTesoroNivelComponent,
    NivelCardComponent,
    PremiosGanadosCardComponent,
    CardVideoComponent,
    TemploSabiosCardComponent,
    PreguntaOpcionesComponent,
    PreguntaVerdaderoFalsoComponent,
    PreguntaCreaComponent,
    BusquedaTesoroActivoComponent,
    BusquedaTesoroHeaderComponent,
    MenuComponent,
    ModalVideoComponent,
    ModalAcercaDeComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts